import { buildBoothDeck } from '../_booth-base/booth-base';
import { DATA_AI_CONFIG } from './config';

export default buildBoothDeck(DATA_AI_CONFIG);
